import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {FormHelperText, TextField, FormControlLabel} from "@material-ui/core";
import IntlMessages from "../../../util/IntlMessages";
import {useForm} from "react-hook-form";
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {addBRValidation} from "../../../actions";
import BRTargetsProvidingTable from "./BRTargetsProvidingTable";
import BRDomainsProvidingTable from "./BRDomainsProvidingTable";
import BRSubdomainsProvidingTable from "./BRSubdomainsProvidingTable";
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import BRServicesTechnicalTable from "../BreachRiskReport/BRServicesTechnicalTable";
import BRSubdomainsTechnicalTable from "../BreachRiskReport/BRSubdomainsTechnicalTable";
import BRTechnicalTargetsTable from "../BreachRiskReport/BRTechnicalTargetsTable";

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(2),
        minWidth: 120,
    },
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '50ch',
        },
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const Form = (props) => {
    const classes = useStyles();
    const {targetEntityId, portfolioView=false} = props;

    // console.log("Displaying Sharing invitation form. Entity ID is", targetEntityId)

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const {didJustCreateNewValidation} = useSelector(({breachrisk}) => breachrisk.appMisc);
    const {customerInView} = useSelector(({customer}) => customer);
    const dispatch = useDispatch();

    const [signAttestation, setSignAttestation] = useState("");
    const [comments, setComments] = useState(null);
    const [entityId, setEntityId] = useState(targetEntityId);


    const clearForm = () => {

        setSignAttestation("");
        setComments("");
        document.getElementById('NewBRValidationForm').reset();
    }

    useEffect(() => {
        if(didJustCreateNewValidation) {
            clearForm();
        }
    }, [dispatch, didJustCreateNewValidation]);

    const { register, handleSubmit, errors } = useForm();
    const onSubmit = data => {

        dispatch(addBRValidation({
            isValidated: signAttestation,
            "comments": comments,
            "entityId": entityId,
            customerId: customerInView,
        }));
    }

    /**************************/
    /*End Setup State and Dispatch*/
    /**************************/


    return (
        <div className="animated fadeIn animation-duration-7">
            <div className="row">

                <div className="col-12">
                    <BRTargetsProvidingTable portfolioView={portfolioView}/>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <BRTechnicalTargetsTable portfolioView={portfolioView}/>
                </div>
            </div>
            <div className="row">

                <div className="col-12">
                    <BRDomainsProvidingTable portfolioView={portfolioView}/>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <BRServicesTechnicalTable portfolioView={portfolioView}/>
                </div>
            </div>

            <div className="row">

                <div className="col-12">
                    <BRSubdomainsProvidingTable portfolioView={portfolioView}/>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <BRSubdomainsTechnicalTable portfolioView={portfolioView}/>
                </div>
            </div>
            <form id={"NewBRValidationForm"} className={classes.root}>

                <h3>Comments (optional)</h3>
                <TextField
                    label={<IntlMessages id="appModule.newBRBusinessShare.comments"/>}
                    fullWidth
                    id="comments"
                    name="comments"
                    // required
                    error={!!errors.comments}
                    onChange={(event) => setComments(event.target.value)}
                    defaultValue={comments}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    // inputRef={register({
                    //     required: "This field is required." ,
                    //     // pattern: /^([a-z0-9\s]+,)*([a-z0-9\s]+){1}$/i
                    // })}
                    helperText={ errors.comments?.message}
                />
                <br/>
                <h3>Attestation</h3>
                <FormControl>
                    <FormControlLabel

                        control={
                            <Checkbox
                                id="signAttestation"
                                name="signAttestation"
                                checked={signAttestation}
                                onChange={(event) => setSignAttestation(event.target.checked)}
                                required
                                inputRef={register({
                                    validate: value => value === true || "You must check this box to make this attestation. Checking this box consititutes your signature.",
                                })}
                            />
                        }
                        label={<>I attest that the IP Addresses, Domains, and Subdomains listed above comprise my entire publicly-accessible IT infrastructure to the best of my knowledge.</>}

                    />
                    <FormHelperText
                        error={!!errors.signAttestation}
                    >
                        {errors.signAttestation? errors.signAttestation?.message : " "}
                    </FormHelperText>
                </FormControl>
                <br/>
                <em>By checking the box above and submitting, you attest that the IP Addresses, Domains, and Subdomains shown on the Verify & Integrate page include all elements of your publicly-accessible IT assets to the best of your knowledge. If your BreachRisk™ Score or BreachRisk™ Report is disputed, this attestation may be used as justification of our conclusions. We reserve the right to contest and invalidate this attestation if our observations yield contradictory evidence, and such contradiction could result in lower fidelity or less desirable conclusions.</em>

                <div className="mb-3 d-flex align-items-center justify-content-between">


                    <Button onClick={handleSubmit(onSubmit)}
                            id={"AddAttestationButton"}
                            disabled={!!errors.domain || !!errors.signAttestation}
                            variant="contained" color="primary">
                        <IntlMessages id="form.attest"/>
                    </Button>
                </div>

            </form>

        </div>
    );

}

export default Form